import React, { useLayoutEffect } from "react";
import { StyleSheet, View, ScrollView } from "react-native";
import { colors } from "src/assets";
import { ReviewCard } from "src/components";
import { NotFound } from "./components";
import { useReviewByUserAsServiceOwner } from "src/hooks";
import { useNavigation, useRoute } from "@react-navigation/native";
import { RootStackScreenProps } from "src/navigation/types";

export type ReviewByUserAsServiceOwnerNavigationParam = {
  id: string;
  title: string;
  notFound: string;
};

export const ReviewByUserAsServiceOwnerScreen: React.FC = () => {
  const navigation =
    useNavigation<
      RootStackScreenProps<"ReviewByUserAsServiceOwner">["navigation"]
    >();
  const route =
    useRoute<RootStackScreenProps<"ReviewByUserAsServiceOwner">["route"]>();
  useLayoutEffect(() => {
    navigation.setOptions({ title: route.params.title });
  }, [navigation, route.params.title]);
  const [items, loading] = useReviewByUserAsServiceOwner(route.params.id);
  return (
    <View
      style={[
        styles.container,
        items.length === 0 && !loading ? styles.notFound : {},
      ]}
    >
      {items.length > 0 ? (
        <ScrollView>
          {items.map((item) => (
            <ReviewCard
              key={item.id}
              review={item}
              containerStyle={styles.card}
              onPress={() => console.log("onReview...")}
            />
          ))}
        </ScrollView>
      ) : null}
      {items.length === 0 && !loading ? (
        <NotFound text={route.params.notFound} />
      ) : null}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.white,
  },
  notFound: {
    backgroundColor: colors.gray1,
  },
  card: {
    marginVertical: 8,
    marginHorizontal: 8,
  },
});
